import { useEffect, useRef } from 'react';
import { ConversationTranscript, useConversationTranscript } from '@/entities/conversations';
import { useDialogSessionOptional } from '@/features/DialogSession';

type UseTranscriptDataResult = {
  data: ConversationTranscript[];
  isSuccess: boolean;
  isLoading: boolean;
  transcriptContainerRef: React.RefObject<HTMLDivElement | null>;
};

export const useTranscriptData = (dialogId: number, anonymized = true): UseTranscriptDataResult => {
  const dialogSession = useDialogSessionOptional();
  // При активной DialogSession транскрипт берётся из сессии, поэтому собственный запрос секции
  // отключаем (id === undefined → enabled:false), чтобы не держать лишнего подписчика на тот же кэш.
  const transcriptQuery = useConversationTranscript(dialogSession ? undefined : dialogId, anonymized);
  const transcriptContainerRef = useRef<HTMLDivElement>(null);

  const data = dialogSession ? (dialogSession.transcriptsQuery.data ?? []) : (transcriptQuery.data ?? []);
  const isSuccess = dialogSession ? dialogSession.transcriptsQuery.isSuccess : transcriptQuery.isSuccess;
  const isLoading = dialogSession ? dialogSession.transcriptsQuery.isLoading : transcriptQuery.isLoading;

  useEffect(() => {
    if (!dialogSession) return;
    dialogSession.registerTranscriptContainer(transcriptContainerRef);
    return () => {
      dialogSession.registerTranscriptContainer(null);
    };
  }, [dialogSession]);

  return { data, isSuccess, isLoading, transcriptContainerRef };
};
